import { pendingRequestsCount } from "@/api/generated";
import { queryOptions, skipToken } from "@tanstack/react-query";

type PendingRequestsScope = { tenantId?: number; branchId?: number; userId?: number };

export const pendingRequestQueries = {
  all: () => ["pending-requests"] as const,
  /** How many member requests wait for review in the current family, branch, and account. */
  counts: ({ tenantId, branchId, userId }: PendingRequestsScope) =>
    queryOptions({
      queryKey: [...pendingRequestQueries.all(), "counts", tenantId, branchId, userId] as const,
      queryFn:
        tenantId && branchId && userId
          ? async ({ signal }) => (await pendingRequestsCount({ signal })).data.data
          : skipToken,
      // The sidebar mounts with every page. Writes invalidate the counts (see app.tsx), so a page visit reuses them and
      // requests from other members still appear within a minute.
      staleTime: 60_000,
    }),
};
